import { MiniMap, useReactFlow, type Node } from '@xyflow/react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { NODE_TYPE_COLORS, type StudioNodeData } from '@/features/studio/canvas/types'

function minimapNodeColor(node: Node): string {
  const data = node.data as StudioNodeData | undefined
  if (!data?.nodeType) return '#475569'
  if (data.nodeType === 'group') {
    return data.groupMeta?.color ?? NODE_TYPE_COLORS.group
  }
  return NODE_TYPE_COLORS[data.nodeType] ?? '#6366f1'
}

function minimapNodeStroke(node: Node): string {
  return node.selected ? '#e2e8f0' : 'rgba(15, 23, 42, 0.35)'
}

/** 右下角小地图：拖拽平移 · 滚轮缩放 · 点击跳转视口 */
export function CanvasMiniMap() {
  const { t } = useTranslation()
  const rf = useReactFlow()

  const onMiniMapClick = useCallback(
    (_event: React.MouseEvent, position: { x: number; y: number }) => {
      void rf.setCenter(position.x, position.y, { duration: 220, zoom: rf.getZoom() })
    },
    [rf],
  )

  return (
    <MiniMap
      className="studio-canvas-minimap"
      position="bottom-right"
      ariaLabel={t('canvas.minimap.ariaLabel')}
      pannable
      zoomable
      zoomStep={0.5}
      offsetScale={4}
      style={{ width: 220, height: 152, margin: '0 14px 14px 0' }}
      nodeColor={minimapNodeColor}
      nodeStrokeColor={minimapNodeStroke}
      nodeStrokeWidth={1.5}
      nodeBorderRadius={4}
      maskColor="rgba(12, 12, 16, 0.78)"
      maskStrokeColor="rgba(129, 140, 248, 0.65)"
      maskStrokeWidth={1}
      bgColor="rgba(14, 14, 18, 0.94)"
      onClick={onMiniMapClick}
    />
  )
}
